import { render } from "./PageWindowBar.vue?vue&type=template&id=fd3f28e4"
import script from "./PageWindowBar.vue?vue&type=script&lang=js"
export * from "./PageWindowBar.vue?vue&type=script&lang=js"

import "./styles/PageWindowBar.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__